import React from 'react';
import { useIsDesktopDimension } from '@beef/ui-kit';
import { ContentWrapper } from "./components/ContentWrapper";
import { ActionBarRC, PopularRegionsRC, RegionListRC, RegionModalLayoutRC, SearchRC, SearchResultsRC } from "./connected";
import { ScrollableWrapper } from "./components/ScrollableWrapper";
export var RegionModalRC = function RegionModalRC() {
  var isDesktop = useIsDesktopDimension();
  return /*#__PURE__*/React.createElement(RegionModalLayoutRC, {
    "data-t-id": "components-RegionModal"
  }, isDesktop && /*#__PURE__*/React.createElement(ActionBarRC, null), /*#__PURE__*/React.createElement(ContentWrapper, null, /*#__PURE__*/React.createElement(SearchRC, {
    "data-t-id": "components-RegionModal"
  }), /*#__PURE__*/React.createElement(ScrollableWrapper, null, /*#__PURE__*/React.createElement(PopularRegionsRC, {
    "data-t-id": "components-RegionModal"
  }), /*#__PURE__*/React.createElement(SearchResultsRC, null), /*#__PURE__*/React.createElement(RegionListRC, {
    columns: isDesktop ? 4 : 2
  }))));
};